module.exports = __webpack_public_path__ + "9779d9a1/img/pdf-icon.79f04a36.svg";